import { createSlice } from '@reduxjs/toolkit';

import { DEFAULT_HASH } from '../../components/_workspace/WorkspaceLocationHash';
import { SidebarState } from './actions';

const initialState: SidebarState = {
  currentTab: DEFAULT_HASH,
  shouldShowNewRecordingModal: false,
  shouldShowInviteModal: { visible: false, location: '' },
  shouldShowReferralModal: false,
  shouldRedirectToUsersSettings: false,
  shouldShowEditProfileModal: false,
  shouldShowProFeatureGateModal: {
    visible: false,
    location: null,
    featureType: null
  }
};

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    switchToTab: (state, action) => {
      state.currentTab = action.payload;
    },
    showNewRecordingModal: (state, action) => {
      state.shouldShowNewRecordingModal = action.payload;
    },
    showInviteModal: (state, action) => {
      state.shouldShowInviteModal = action.payload;
    },
    showReferralModal: (state, action) => {
      state.shouldShowReferralModal = action.payload;
    },
    showEditProfileModal: (state, action) => {
      state.shouldShowEditProfileModal = action.payload;
    },
    redirectToUsersSettings: (state, action) => {
      state.shouldRedirectToUsersSettings = action.payload;
    },
    showProFeatureGateModal: (state, action) => {
      const { visible, location, featureType } = action.payload;

      state.shouldShowProFeatureGateModal = { visible, location, featureType };
    }
  }
});

export default sidebarSlice.reducer;
